import { useGetFieldDisplayName } from 'modules/queryBuilder/hooks/useGetFieldDisplayName';
import { ClientDataType } from 'modules/queryBuilder/types';

export const useGetUserFieldDisplayName = () => {
  const { getFieldDisplayName: getGenericFieldDisplayName } = useGetFieldDisplayName();
  const getFieldDisplayName = (field: string): string =>
    getGenericFieldDisplayName(field, ClientDataType.User);
  return { getFieldDisplayName };
};
